import React, { ReactNode } from 'react';
import { withRouter } from 'react-router';
import { ContractNoticeComponentView } from './ContractNoticeComponentView';
import { WprRadio } from '../../wpr-framework/component/controls/WprRadio';
import { WprButton } from '../../wpr-framework/component/controls/WprButton';
import { WprContainer } from '../../wpr-framework/component/controls/WprContainer';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';
import { WprRowInfo } from '../../wpr-framework/component/props/WprRowInfo';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';

/**
 * 重要項目のご確認
 */
class ContractNoticeComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new ContractNoticeComponentView(), props);
	}

	public handleClick = (e: React.MouseEvent, props) => {
		e.nativeEvent.stopImmediatePropagation();
		const targetId = e.currentTarget.id;
		$('#' + targetId.replace('-lbl', '')).off('click');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="done"><span>1</span></li>
								<li className="done"><span>2</span></li>
								<li className="now">
									<span>3</span><p className="conf" id="step3">重要項目のご確認</p>
								</li>
								<li><span>4</span></li>
							</ul>
						</div>
					</div>
				</div>
				<div className="page-kokuchi">
					<div className="top">
						<h1>告知事項と重要事項を<br />ご確認ください</h1>
					</div>
					<div className="announce">
						<h2 className="c-headline">告知事項</h2>
						<div className="kokuchijikou">
							<div className="c-tit">
								<h3>下記内容をご確認ください</h3>
							</div>
							<ol>
								{this.renderList('ContractNoticeInfo')}
							</ol>
							<div className="imp">
								<div className="wrap">
									<p>*危険な仕事および運動については、「重要事項説明書」の注意喚起情報　告知義務・通知義務の項目をご覧ください。</p>
									<p>{' '}☆★の項目は、ご契約に際して保険会社がおたずねする特に重要な事項（告知事項）。</p>
									<p>★印の項目は、ご契約後に変更が生じた際に保険会社にご連絡をいただく必要のある事項（通知事項）です。</p>
									<p>ご回答が事実と相違している場合には、保険契約を解除する場合や、保険金をお支払いできない場合がありますのでご注意ください。</p>
								</div>
							</div>
						</div>
						<div className="answer">
							<WprRadio id="id-answer-yes" name="answer" view={this.view} value="yes" />
							<label className="answer-button yes" htmlFor="id-answer-yes" id="id-answer-yes-lbl" onClick={e => this.handleClick(e, this.props)}>
								<span>全て「はい」</span>
							</label>
							<WprRadio id="id-answer-no" name="answer" view={this.view} value="no" />
							<label className="answer-button no" htmlFor="id-answer-no" id="id-answer-no-lbl" onClick={e => this.handleClick(e, this.props)}>
								<span>1つでも「いいえ」</span>
							</label>
						</div>
					</div>
					<div className="ex">
						<h2 className="c-headline">重要事項説明書</h2>
						<div className="wrap-ex">
							<p>
								重要事項説明書・意向確認書をダウンロードいただき、
								<br className="c-pc-br" />
								ご契約前に必ずご一読のうえ、お申込み手続きに進んでください。
							</p>
						</div>
						<WprButton className="c-pdf-button" name="pdf" view={this.view}>
							<div className="logo" />
							<span>PDF重要事項説明書</span>
						</WprButton>
						<p className="pdf-imp">※PDFファイルには意向確認書も含まれます</p>
						<div className="next">
							<WprButton className="c-button" name="next" view={this.view}>
								<span>
									「重要事項説明書」の内容に確認のうえ
									<br />
									申込みに進む
								</span>
							</WprButton>
						</div>
						<div className="transition">
							<WprButton className="c-btn-prev" name="prev" view={this.view}>
								<span>1つ前の画面に戻る</span>
							</WprButton>
						</div>
					</div>
				</div>
				<WprContainer mode="no" view={this.view}>
					<div className="c-layer">
						<div className="box">
							<h1>申し訳ありません</h1>
							<p>
								告知事項の内容に一つでもご同意いただけない場合はお申込みができません
							</p>
							<WprButton className="button" name="box-button" view={this.view}>
								OK
							</WprButton>
						</div>
					</div>
				</WprContainer>
				<FooterComponent />
			</>
		);
	}

	/**
	* リスト描画
	* @param listName リスト名
	* @param rowInfo 行情報
	*/
	protected onRenderList(listName: string, rowInfo: WprRowInfo): any {
		if (listName === 'ContractNoticeInfo') {
			return (
				<li key={rowInfo.index}>
					<WprSpan name="noticeMessage" view={this.view} row={rowInfo}></WprSpan>
				</li>
			);
		}
		return null;
	}
	// --------------------------------------------------------------------------
}

export default withRouter(ContractNoticeComponent);